module.exports = __webpack_public_path__ + "img/laporanstok.7d9346e9.jpg";